





























import { EventInterface, PersistedEventInterface } from "@/types";
import Event from "@/classes/Event";
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class NextEvent extends Vue {
  private header: string = "NEXT EVENT";
  private nextEvent?: PersistedEventInterface | false = false;

  async getNextMainEvent() {
    const today = new Date().toISOString().substring(0, 10);
    const response = await this.axios.get("/arma/events", {
      params: {
        mainEvent: "1",
        "sort[asc]": "date",
        "date[gte]": today,
      },
    });

    return new Event(response.data[0]);
  }

  async mounted() {
    this.nextEvent = await this.getNextMainEvent();
  }
}
